import DashboardSingleStats from "./dashboard-single-stats";

export default DashboardSingleStats;
